import React from 'react';
import { User } from 'lucide-react';

const CLOCKED_IN = [
  { id: 'worker-012', name: 'Amara Okafor', role: 'Senior Carer', since: '07:00', client: 'M. Henderson', hours: '0h 18m' },
  { id: 'worker-019', name: 'Cian Walsh', role: 'Care Worker', since: '06:30', client: 'R. Thornton', hours: '0h 48m' },
  { id: 'worker-031', name: 'Priya Nair', role: 'Care Worker', since: '07:15', client: 'D. Blackwell', hours: '0h 03m' },
  { id: 'worker-008', name: 'Fatima Byrne', role: 'Senior Carer', since: '06:00', client: 'A. Griffiths', hours: '1h 18m' },
];

export default function LiveClockedInPanel() {
  return (
    <div className="bg-card border border-border rounded-xl p-5">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <div className="w-2 h-2 rounded-full bg-success animate-pulse" />
          <h3 className="text-[14px] font-600 text-foreground">Currently Clocked In</h3>
          <span className="text-[11px] font-500 bg-success/10 text-success px-2 py-0.5 rounded-full">{CLOCKED_IN?.length} active</span>
        </div>
        <span className="text-[11px] text-muted-foreground">Live · updates every 60s</span>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
        {CLOCKED_IN?.map((w) => (
          <div key={w?.id} className="flex items-start gap-3 p-3 rounded-lg bg-success/5 border border-success/15">
            <div className="w-8 h-8 rounded-full bg-primary/10 flex items-center justify-center shrink-0">
              <User size={14} className="text-primary" />
            </div>
            <div className="min-w-0">
              <p className="text-[13px] font-600 text-foreground truncate">{w?.name}</p>
              <p className="text-[11px] text-muted-foreground">{w?.role}</p>
              <p className="text-[11px] text-muted-foreground mt-1">Since {w?.since} · {w?.hours}</p>
              <p className="text-[11px] font-500 text-success truncate">Client: {w?.client}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}